import Main from './Main.jsx';

export default function Food(){

  return(
      <div>
        <Main />
      </div>);
}
